import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { GlobalDataService } from '@providers/global-data/global-data.service';

@Component({
  selector: 'app-showrooms',
  templateUrl: './showrooms.component.html',
  styleUrls: ['./showrooms.component.less']
})
export class ShowroomsComponent implements OnInit {
  area: String;
  projectObserver: Subscription;

  constructor(private globalDataService: GlobalDataService) {
    this.area = 'paris';
  }

  ngOnInit() {
    this.projectObserver = this.globalDataService
      .getCurrentProject()
      .subscribe((project: any) => {
        if (project == null) {
          return;
        }

        if (project._related && project._related.addresses && project._related.addresses[0] && project._related.addresses[0].city) {
          this.area = project._related.addresses[0].city;
        }
      });
  }

  ngOnDestroy() {
    this.projectObserver.unsubscribe();
  }
}
